var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 2.55252L9.428 5.38119L2.828 11.9805H0V9.15186L6.6 2.55186V2.55252ZM7.54267 1.60986L8.95667 0.195191C9.08169 0.0702104 9.25122 0 9.428 0C9.60478 0 9.77432 0.0702104 9.89933 0.195191L11.7853 2.08119C11.9103 2.20621 11.9805 2.37575 11.9805 2.55252C11.9805 2.7293 11.9103 2.89884 11.7853 3.02386L10.3707 4.43786L7.54267 1.60986Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.2e9c169dd438e5032eeff5fdb79fe2bf.svg";
export { ForwardRef as ReactComponent };